var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('notification-list'),(_vm.store.user.isAuthenticated)?_c('Navbar'):_vm._e(),_c('v-main',[_c('transition',{attrs:{"appear":"","name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }